import { PropertyTypeStoreService } from '@hb/modules/property/property-type/property-type-store.service';
import { GlobalControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'property-type-button',
    templateUrl: './property-type-button.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioModule,
        ApButtonGroupComponent,
        ApButtonGroupItemComponent,
        CoApplicantPipe
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: PropertyTypeStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PROPERTY_TYPE_BUTTON_GROUP }
    ]
})
export class PropertyTypeButtonComponent extends GlobalInjectComponent<PropertyTypeStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PropertyTypeStoreService);
    protected readonly type = PropertyType;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<PropertyType>(this.analyticsService, this.questionKey, this.store.getPropertyType());
        this.mainApplicantControl.onUpdate().subscribe((propertyType) => this.store.setPropertyType(propertyType));
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }
}
